import React from 'react';
import './Animation.css';

const Animation = () => {
    
    return (
        <div>
            <div class="lds-roller">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>
    );
};

export default Animation;